import { render, staticRenderFns } from "./HdIconButton.vue?vue&type=template&id=2523aa48"
import script from "./HdIconButton.vue?vue&type=script&lang=js"
export * from "./HdIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports